import PRODUCT_TRANSLATIONS_QUERY from '../queries/PRODUCT_TRANSLATIONS_QUERY.graphql';

const env = process.env.ENV;
const isDev =
  env &&
  env !== 'prod' &&
  (env !== 'test' || window.location.hostname === 'localhost');

export default async (context, locale) => {
  const {market, lang} = context.params || {};
  try {
    const {data, error} = await context.app.apolloProvider.defaultClient.query({
      query: PRODUCT_TRANSLATIONS_QUERY,
      variables: {
        // locale,
        market: market.toLowerCase(),
        language: lang.toLowerCase()
      }
    });
    if (isDev) {
      if (error) {
        console.error(
          '[Catalog] (DEV) Error getting Product Translations. Error:',
          error
        );
      } else {
        console.debug('[Catalog] (DEV) Product Translations:', data);
      }
    }
    return (data || {}).pdpStrings || {};
  } catch (error) {
    if (isDev) {
      console.error(
        '[Catalog] (DEV) Error caught while getting Product Translations. Error:',
        error
      );
    }
  }
  return {};
};
